angular.module('inspecciones')
    .controller('historialdamageController', [
        '$rootScope', '$scope', '$location', '$route', '$routeParams',
        'inspeccionesService', 'infraestructurasAdminService',
        function ($rootScope, $scope, $location, $route, $routeParams,
            inspeccionesService, infraestructurasAdminService) {
            
            $scope.InspeccionId = $routeParams.inspeccionId;
            $scope.dañoADIFId = $routeParams.id;

            $scope.danios = [];
            $scope.selectedDamage = null;

            // Cargar daños históricos
            inspeccionesService
                .getDañosCompletosPorCodigo($scope.dañoADIFId)
                .then(function (response) {

                    $scope.danios = response.data || [];

                    // Si no hay historial
                    if ($scope.danios.length === 0) {

                        console.warn(
                            'No se han encontrado daños históricos para el daño:',
                            $scope.dañoADIFId
                        );

                        $scope.Codigo = '';
                        $scope.selectedDamage = null;

                        return;
                    }

                    // Código del daño
                    $scope.Codigo = $scope.danios[0].Codigo;

                    // Seleccionamos el primero
                    $scope.selectedDamage = $scope.danios[0];

                    // Cargar imágenes solamente cuando existen
                    $scope.danios.forEach(function (danio) {

                        if (!danio.Imagen) {
                            danio.Imagen = null;
                            return;
                        }

                        inspeccionesService
                            .getImagen(danio.Id)
                            .then(function (res) {

                                var blob = new Blob(
                                    [res.data],
                                    {
                                        type: res.headers(
                                            'Content-Type'
                                        )
                                    }
                                );

                                danio.Imagen =
                                    URL.createObjectURL(blob);

                            })
                            .catch(function (error) {

                                console.warn(
                                    'Imagen no disponible para daño:',
                                    danio.Id
                                );

                                danio.Imagen = null;
                            });
                    });

                })
                .catch(function (error) {

                    console.error(
                        'Error cargando historial del daño:',
                        error
                    );

                    $scope.danios = [];
                    $scope.selectedDamage = null;
                });


            $scope.seleccionarDanio = function (danio) {
                $scope.selectedDamage = danio;
            };

            $scope.volver = function () {
                $location.path('/damagesADIF/' + $scope.InspeccionId + '/' + $scope.dañoADIFId);
                $rootScope.inspeccionUrl = true;
                $rootScope.damageUrl = true;
            };

            $scope.verCategorias = function () {
                $rootScope.inspeccionUrl = false;
                $rootScope.parteUrl = false;
                $rootScope.parteUrl = false;
                $location.path('/categorias');
            };
        }
    ]);
